/* src/app/components/layout/menu/menu.component.scss */
.lexbe-toolbar {
  overflow: hidden;
  white-space: nowrap;
  height: 55px;
  color: rgba(0, 0, 0, 0.87);
  padding-top: 0;
}
.lexbe-toolbar-logo {
  height: 25px;
  padding-right: 40px;
  padding-left: 20px;
  vertical-align: text-bottom;
  line-height: 55px;
}
.menu-bar-button,
.menu-bar-link {
  font-size: 12px;
  font-family: Roboto, sans-serif;
  font-weight: 500;
  color: #838383;
  height: 55px;
  padding: 2px 16px 0;
  border-radius: 0;
}
:host-context(.dark-theme) .menu-bar-button {
  color: #88a3ff;
}
.menu-bar-button.active-menu-item,
.menu-bar-link.active-menu-item {
  color: #000;
}
:host-context(.dark-theme) .menu-bar-button,
:host-context(.dark-theme) .menu-bar-link {
  color: #cbc8c8;
  font-weight: 400;
}
:host-context(.dark-theme) .active-menu-item {
  color: white;
  font-weight: 900;
}
::ng-deep .cdk-overlay-pane .customize_menu_dropdown {
  border-radius: 0;
}
/*# sourceMappingURL=menu.component.css.map */
